export const DataUserTestimonial = [
  {
    id: 1,
    name: "Raihan Ramadhan",
    role: "Back end Developer",
    desc: "It really helped me choose an internship that matched my abilities."
  },
  {
    id: 2,
    name: "Kemas Alvian Ahmad",
    role: "Fullstack Developer",
    desc: "Thank you, KarirKu. Now I know the career I want to pursue after graduation."
  },
  {
    id: 3,
    name: "Fadhil Pratama",
    role: "Front end Developer",
    desc: "The internship options are great and there are plenty to choose from based on what we want."
  },
  {
    id: 4,
    name: "Taufik Kurniawan",
    role: "UIUX",
    desc: "I received an offer after joining an internship here. Excellent."
  }
]
